import { Component, inject, Input, OnInit } from '@angular/core';
import { UserData } from '@ddv/entitlements';
import { ApmService } from '@elastic/apm-rum-angular';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false,
})
export class MainComponent implements OnInit {
    @Input() user: UserData | undefined;

    private readonly apmService = inject(ApmService);

    ngOnInit(): void {
        this.apmService.apm.setUserContext(this.user?.email ? { email: this.user.email } : { username: this.user?.userName });
    }
}
